// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "aphrodite";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text2";
import Link from "@cloudspire/legacy-resources/src/components/Link2";

const styles = StyleSheet.create({
  recaptchaMessage: {
    fontSize: "0.75rem",
  },
  link: {
    textDecoration: "underline",
  },
});

type PropsType = {};

const RecaptchaMessage: React.FunctionComponent<PropsType> = () => {
  const intl = useIntl();

  return (
    <Text aStyle={styles.recaptchaMessage}>
      <div>
        {intl.formatMessage(
          {
            defaultMessage:
              "Cette page est protégé par reCAPTCHA et la <privacyPolicy>politique de vie privée</privacyPolicy> et les <termsOfService>conditions d'utilisation</termsOfService> de Google.",
          },
          {
            termsOfService: (...chunks) => (
              <Link
                aStyle={styles.link}
                key="termsOfService"
                to="https://policies.google.com/privacy"
              >
                {chunks}
              </Link>
            ),
            privacyPolicy: (...chunks) => (
              <Link
                aStyle={styles.link}
                key="privacyPolicy"
                to="https://policies.google.com/terms"
              >
                {chunks}
              </Link>
            ),
          }
        )}
      </div>
    </Text>
  );
};

export default RecaptchaMessage;
